
<template>
<Loader v-if="loader" />

    <div class="card p-3">
      <div class="grid">
          <div class="col-12 lg:col-10">
              <Dropdown v-model="selectedTypeFornitura" :options="typesFornitura" optionLabel="name" optionValue="name" placeholder="Seleziona tipo fornitura" class="inputfield w-full" />
             <div v-show="validationErrors.fornitura && submitted" class="p-error">Seleziona campo.</div>
          </div>
          <div class="col-2 lg:col-2">
            <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="w-full" />
          </div>
      </div>
    </div>

    <div v-if="hasSearched && items && items.length <= 0">
      <Message severity="warn"> 
        Non ci sono risultati.
      </Message>
    </div>

    <div v-show="selectedItems.length > 0" class="btn-selected">
        <Button @click="setInSouspensionOrReactivation" class="p-button-warning p-3"  style="min-width:200px">
          Inoltra {{selectedItems.length}} elementi <i class="pi pi-send ml-5" style=""></i>
        </Button>
    </div>

    <div class="mt-3" v-if="items.length > 0">

      <div v-if="items.some(el => el.duplicate)">
        <Message severity="warn"> 
          Attenzione ci sono forniture duplicate
        </Message>
      </div>
      <div v-if="items.some(el => el.sameType)">
        <Message severity="warn"> 
          Attenzione ci sono forniture che hanno lo stato attuale uguale all'operazione da effettuare
        </Message>
      </div>
      <div v-if="items.some(el => el.out)">
        <Message severity="warn"> 
          Attenzione ci sono forniture uscite
        </Message>
      </div>
      <div v-if="items.some(el => !el.isDisalimentabile)">
        <Message severity="warn"> 
          Attenzione ci sono forniture non disalimentabili
        </Message>
      </div>
      <div v-if="items.some(el => el.udd && el.udd.includes('ANTARES')) && moment(new Date()).day() != 1">
        <Message severity="warn"> 
          Attenzione ci sono forniture con udd ANTARES che permette l'invio solo il lunedì
        </Message>
      </div>

      <div>
        <DataTable ref="dt" :value="items" v-model:selection="selectedItems" responsiveLayout="scroll" :filters="filters">
          <template #header>
              <div class="flex justify-content-between flex-wrap">
                  <div class="flex align-items-center justify-content-center mb-2">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                    </span>
                  </div>
                  <div class="flex align-items-center justify-content-center">
                    <Button v-if="selectedItems.length > 0" icon="pi pi-trash" :label="` Elimina (${selectedItems.length})`" @click="deletePreview(selectedItems)" class="p-button-danger mx-2" />
                    <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV()" class="p-button-secondary mx-2" />
                  </div>
              </div>
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column field="code" header="Fornitura"></Column>
          <Column field="cc" header="Cc"></Column>
          <Column field="udd" header="Udd"></Column>
          <Column field="date" header="Data in preview" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.date)}}     
            </template>
          </Column>
          <Column field="data_inizio" header="Data Inizio" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.data_inizio)}}     
            </template>
          </Column>
          <Column field="data_fine" header="Data fine" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.data_fine)}}     
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true" />
          <Column field="rappresentante" header="Rappresentante" :sortable="true" />
          <Column field="agente" header="Agenzia" :sortable="true" />
          <Column field="agente_firmatario" header="Agente firmatario" :sortable="true" />
          <Column field="stato_fornitura" header="Stato Interno Attuale" :sortable="true" />
          <Column field="type" header="Tipo pratica" :sortable="true" />
          <Column field="disalimentabile" header="Disalimentabile">
            <template #body="{data}">
              <p v-if="data.disalimentabile == 'Y'"> Si</p>
              <p v-else-if="data.disalimentabile == 'N'"> No</p>   
            </template>
          </Column>
          <Column field="saldo" header="Saldo" :sortable="true" />
          <Column field="user" header="Gestito da" :sortable="true" />
          <Column>
            <template #body="{data}">
              <ul>
                <li class="p-error text-xs" v-if="data.duplicate"> Duplicato</li>
                <li class="p-error text-xs" v-if="data.sameType"> Stato attuale uguale all'operazione</li>
                <li class="p-error text-xs" v-if="data.out"> Fornitura uscita</li>
                <li class="p-error text-xs" v-if="!data.isDisalimentabile"> Fornitura non disalimentabile</li>
                <li class="p-error text-xs" v-if="data.tutelaLavorazione"> Fornitura in tutela lavorazione</li>
              </ul>
            </template>
          </Column>  
          <Column>
            <template #body="{data}">
                <i @click="deletePreview(data)" class="pi pi-trash"></i>
              </template>
          </Column>          
        </DataTable>
      </div>
    </div>
</template>

<script>

import Service from '@/services/ask-pratiche/pratiche-service'
import ServiceOperation from '@/services/ask-operation/operation-service'
import { getCurrentInstance, ref } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import moment from 'moment';
import { useToast } from "primevue/usetoast";

export default {
    components: {
      Loader
    },
     setup() {
        
      const dt = ref();
      const toast = useToast();
      const loader = ref(false);
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const serviceOperation = new ServiceOperation(self.$http, self.$eventBus)
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const validationErrors = ref({})
      const submitted = ref(false)
      const items = ref([])
      const selectedItems = ref([])
      const selectedTypeFornitura = ref()
      const typesFornitura = ref([
        {name: 'TUTTI'},
        {name: 'POD'},
        {name: 'PDR'},
      ])
      const selectedTypePratica = ref()
      const hasSearched = ref(false)

      const searchData = () => {

        submitted.value = true
        if (validateForm()) {
          loader.value = true
          service.previewRilascioTutela(selectedTypeFornitura.value)
          .then((res) => {
            items.value = res.items
            checkErrors()
            hasSearched.value = true
          }).finally(()=>{
            loader.value = false
          })
        }
      }

      const setInSouspensionOrReactivation = () => {
        loader.value = true
        serviceOperation.setRilascioTutela(selectedItems.value)
        .then((res) => {
          toast.add({severity:'success', summary: 'Successo', detail: res.items.msg});
          deletePreview(selectedItems.value)
        }).finally(()=>{
          loader.value = false
        })
      }

      const deletePreview = (data) => {
        loader.value = true
        let objs = []
        if (Array.isArray(data)) {
            objs = data
        } else {
            objs = [data]
        }
        serviceOperation.deletePreviewRilascioTutela(objs)
        .then(() => {
          searchData()
          selectedItems.value = []
        }).finally(()=>{
          loader.value = false
        })
      }

      const checkErrors = () => {
        let today = moment()
        let codes = items.value.map(item => item.code);
        let d = codes.filter((item, index) => codes.indexOf(item) !== index);
        let duplicates = [...new Set(d)];

        items.value.map(el => {
          el.tutelaLavorazione = false
          el.duplicate = false
          el.sameType = false
          el.out = false
          el.isDisalimentabile = false
          if (duplicates.includes(el.code)) {
            el.duplicate = true
          }
          if (((el.stato_fornitura == 'Riattivazione richiesta' || el.stato_fornitura == 'Riattivazione in lavorazione' || el.stato_fornitura == 'In riattivazione') && el.type == 'riattivazioni') || 
            ((el.stato_fornitura == 'Sospensione richiesta' || el.stato_fornitura == 'Sospensione in lavorazione' || el.stato_fornitura == 'In sospensione') && el.type == 'sospensioni')) {
            el.sameType = true
          }
          if (moment(el.data_fine).isBefore(today, 'day') || !el.data_fine) {
             el.out = true
          }
          if (el.disalimentabile != 'N') {
             el.isDisalimentabile = true
          }
          if (el.stato_tutela == 3) {
            el.tutelaLavorazione = true;
          }
        });
      };

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      
      const validateForm = () =>{
        if (selectedTypeFornitura.value == null)
          validationErrors.value['fornitura'] = true;
        else 
          delete validationErrors.value['fornitura'];
    
        return !Object.keys(validationErrors.value).length;
      }
      

      return {
        moment,
        dt,
        loader,
        filters,
        validationErrors,
        submitted,
        typesFornitura,
        selectedTypeFornitura,
        selectedTypePratica,
        searchData,
        items,
        selectedItems,
        setInSouspensionOrReactivation,
        deletePreview,
        formatDate,
        exportCSV,
        hasSearched
      }
    }
}
</script>

<style scoped>
.btn-selected {
  position:fixed;
  bottom:60px; 
  right:40px;
  z-index:2;
}
.pi-trash {
  color: rgb(254, 88, 88);
  cursor: pointer;
}
</style>
